import './FullScreenLoader.less';

const FullScreenLoader: React.FC = () => {
    return (
        <div className="qpd-rstr-fullscreen-loader">
            <img src={process.env.REACT_APP_FULL_SCREEN_LOADER} />
            <div>Загружаем...</div>
        </div>
    );
};

export default FullScreenLoader;
